export const MOBILE_SECTION_DIVIDER_COLOR = '#E0E0E0'
